/**
 * Same rules as covecms `src/lib/map-image-zoom.ts` (keep in sync when changing).
 */
export const IMAGE_MAP_MIN_ZOOM_FOR_CONSTRUCTOR = -20;
export const IMAGE_MAP_ZOOM_SNAP = 0.25;
export const IMAGE_MAP_ZOOM_DELTA = 0.25;

/** @param {number} fitZoom @param {number} [extraZoomOutSteps=1] */
export function getImageMapMinZoomAfterFit(fitZoom, extraZoomOutSteps = 1) {
  return fitZoom - extraZoomOutSteps;
}

export function getImageMapMaxZoom(width, height) {
  const w = width > 0 ? width : 0;
  const h = height > 0 ? height : 0;
  if (w === 0 && h === 0) {
    return 18;
  }
  const maxDim = Math.max(w, h, 1);
  const z = Math.ceil(Math.log2(maxDim)) + 1;
  return Math.min(22, Math.max(4, z));
}
